// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { DataCacheTool } from "../DataCacheTool.js";
import { ThemeManager } from "../../../Controls/misc/ThemeManager.js";
import { SolidBrush } from "../../Graphics.js";
import { DynProperty } from "../../DynProperty.js";

export let ElliotWavesDataCacheTool = function (toolType)
{
    DataCacheTool.apply(this)
    this.ToolType = toolType

    switch (toolType)
    {
        case DataCacheToolToolType.ElliottImpulse:
            this.InitPoints(6)
            this.Color = "#00FF0B"//"#00FF0D"
            break;
        case DataCacheToolToolType.ElliottCorrection:
            this.InitPoints(4)
            this.Color = "#FFB300"//"#EBB400"
            break;
        case DataCacheToolToolType.ElliottTriangle:
            this.InitPoints(6)
            this.Color = "#FF3400"//"#EB3300"
            break;
        case DataCacheToolToolType.ElliottTripleCombo:
            this.InitPoints(6)
            this.Color = "#FF00C7"//"#EB00C8"
            break;
        case DataCacheToolToolType.ElliottDoubleCombo:
            this.InitPoints(4);
            this.Color = "#00FFE0"//"#00FFE1"
            break;
    }
}

ElliotWavesDataCacheTool.prototype = Object.create(DataCacheTool.prototype)

ElliotWavesDataCacheTool.prototype.MinPointsCount = function () { return this.Points.length }

ElliotWavesDataCacheTool.prototype.ThemeChanged = function (applyToTable)
{
    DataCacheTool.prototype.ThemeChanged.call(this, applyToTable);

    this.labelBackgroundColor = ThemeManager.CurrentTheme.ElliotLabelsBGColor
    this.labelBackgroundBrush = new SolidBrush(this.labelBackgroundColor);
    this.FontColor = ThemeManager.CurrentTheme.Chart_PlateTextColor;
    this.font = ThemeManager.Fonts.Font_8F_regular;
}

ElliotWavesDataCacheTool.prototype.Properties = function ()
{
    var props = DataCacheTool.prototype.Properties.apply(this)

    if (this.FontColor)
        props.push(new DynProperty("ElliotWaves.Font", this.FontColor, DynProperty.COLOR, DynProperty.VISUAL_GROUP))

    return props
}

ElliotWavesDataCacheTool.prototype.callBack = function (properties)
{
    DataCacheTool.prototype.callBack.call(this, properties)

    var prop = DynProperty.getPropertyByName(properties, "ElliotWaves.Font")
    if (prop) this.FontColor = prop.value
}

